export default __webpack_public_path__ + "static/media/multiply_gray.85033228.svg";